// @flow

import { markGovCloudRegionsAsNotSelectable } from '../common-utils/utils';
import { IS_FEDRAMP_LIVE_IN_CE1 } from '../constants';

import { useIsFedRAMPEstimate } from './useIsFedRAMPEstimate';

// Once FedRAMP is live, GovCloud regions are reserved for FedRAMP estimates. Every region dropdown
// of a non-FedRAMP estimate runs its options through this hook, so an older estimate which already
// has a GovCloud region selected still displays it while no new one can be selected.
export const useRegionOptionsWithGovCloudDisabledIfRequired = (regionOptions) => {
  const isFedRAMPEstimate = useIsFedRAMPEstimate();

  // Until FedRAMP is live, nothing changes for any estimate.
  if (!IS_FEDRAMP_LIVE_IN_CE1) {
    return regionOptions;
  }

  // A FedRAMP estimate is the one flow which is allowed to pick GovCloud regions.
  // It may pick any region the dropdown offers. So, no filtering required.
  if (isFedRAMPEstimate) {
    return regionOptions;
  }

  return markGovCloudRegionsAsNotSelectable(regionOptions);
};
